import { Component } from '@angular/core';
import { SignupComponent } from '../../components/signup/signup.component';
import { RouterModule } from '@angular/router';
import { getUrlPathWithSuffix, pathNames } from '../../utilities/routing-path-utils';
import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-signup-page',
  standalone: true,
  imports: [
    SignupComponent,
    RouterModule,
    NgIf,
    MatButtonModule
  ],
  templateUrl: './signup-page.component.html',
  styleUrl: './signup-page.component.scss'
})
export class SignupPageComponent {
  loginPath: string = getUrlPathWithSuffix(pathNames.loginPath);
  shouldRenderConfirmation: boolean = false;

  renderConfirmation(){
    this.shouldRenderConfirmation = true;
  }
}
